import Lightbox from './lightbox';

const lightbox = (options = {}) => {
    return new Lightbox(options);
};

export default lightbox;